<template>
  <div>
    <!-- Announcements Goes Here -->
    <div
      v-if="ad"
      class="alert text-white ad alert-dismissible fade show"
      role="alert"
    >
      {{ ad }}
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <!-- header -->
    <div id="nav" class="shadow">
      <div class="container">
        <!-- <input
            class="search-input form-control"
            type="text"
            name="search"
            v-model="search"
            :placeholder="placeholder"
          />
          <button @click="Search()" class="search-btn btns form-control">
            Search
          </button> -->
        <!-- <h5 class="text-white text-left">Hello World</h5> -->
        <!-- Without User Authenticated -->
        <div class="row justify-content-center">
          <div class="col-sm-6">
            <router-link id="rl" to="/">
              <h4 class="brand text-left">
                <h4 class="text-white logo inline">freelance</h4>
                <strong class="primary-text logo inline">Projects</strong>
              </h4>
            </router-link>
            <!-- smaller device menu -->
            <div >
              <i @click="showMenuForSmallerDevices()" class="fas fa-bars text-right menu-icon text-white"></i>
              <p
                class="fas text-white fa-cog  settingsIcon-sm-device"
                style="cursor:pointer;width: 50px;float: right!important;"
                id="settingsDropDown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></p>
              <div
                style="width:250px!important;"
                class="dropdown-menu px-4 shadow"
                aria-labelledby="settingsDropDown"
              >
                <br />
                <p><strong>Edit your Dashboard!</strong></p>
                <div class="content">
                  <div class="theme">
                    <p style="font-weight: 100;" class="text-left">
                      Theme:
                    </p>
                    <ul class="list-unstyled">
                      <li
                        class="theme-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="default"
                      >
                        <div
                          @click="changeTheme1()"
                          class="first-theme-item"
                        ></div>
                      </li>
                      <li
                        class="theme-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="blue dark"
                      >
                        <div
                          @click="changeTheme2()"
                          class="second-theme-item"
                        ></div>
                      </li>
                      <li
                        class="theme-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="grey dark"
                      >
                        <div
                          @click="changeTheme3()"
                          class="third-theme-item"
                        ></div>
                      </li>
                      <li
                        class="theme-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="brown orange"
                      >
                        <div
                          @click="changeTheme4()"
                          class="fourth-theme-item"
                        ></div>
                      </li>
                      <li
                        class="theme-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="grey dark"
                      >
                        <div
                          @click="changeTheme5()"
                          class="fifth-theme-item"
                        ></div>
                      </li>
                    </ul>
                    <br />
                    <br />
                  </div>
                  <div class="sideMenu">
                    <p style="font-weight: 100;" class="text-left">
                      Side menu:
                    </p>
                    <label class="switch">
                      <input
                        @click="toggleSideBar()"
                        class="checkbox-sidebar"
                        type="checkbox"
                        checked
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
          </div>

          <div class="col-sm-6">
            <div class="header-menus">
              <ul v-if="!token" id="notAuthenticated" class="list-not-auth">
                <li class="text-white m-2">
                  <a
                    href="https://github.com/mouadTaoussi/post-freelance-projects"
                    class="text-white source-code"
                    target="_blank"
                  >
                    Source Code
                    <i class="fas fa-external-link-square-alt"></i>
                  </a>
                </li>
                <li class="mr-2">
                  <router-link
                    class="btn text-white primary btn-sm"
                    to="/projects"
                    ><p style="margin: 0 0 0 0!important;" class="text-white">
                      Projects
                    </p></router-link
                  >
                </li>
                <li class="text-white m-1">
                  <router-link
                    id=""
                    class="btn text-white primary btn-sm"
                    to="/login"
                    >Log In</router-link
                  >
                </li>
                <li class="text-white m-1">
                  <router-link
                    id=""
                    class="btn text-white primary btn-sm"
                    to="/register"
                    >Sign Up</router-link
                  >
                </li>
              </ul>
              <!-- With User Authenticated -->
              <ul v-else class="float-right menu-auth list-unstyled">
                <!--<li class="inline text-white m-2">
                  <router-link id="" class="btn primary btn-sm text-white" to="/">Developer</router-link>
                </li>-->
                <li class="inline mr-2">
                  <router-link id="" class="btn primary btn-sm" to="/projects"
                    >Projects</router-link
                  >
                </li>
                <li class="inline mx-2">
                  <p
                    class="fas text-white fa-cog settingsIcon"
                    style="cursor:pointer;"
                    id="settingsDropDown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  ></p>
                  <div
                    style="width:250px!important;"
                    class="dropdown-menu px-4 shadow"
                    aria-labelledby="settingsDropDown"
                  >
                    <br />
                    <p><strong>Edit your Dashboard!</strong></p>
                    <div class="content">
                      <div class="theme">
                        <p style="font-weight: 100;" class="text-left">
                          Theme:
                        </p>
                        <ul class="list-unstyled">
                          <li
                            class="theme-item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="default"
                          >
                            <div
                              @click="changeTheme1()"
                              class="first-theme-item"
                            ></div>
                          </li>
                          <li
                            class="theme-item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="blue dark"
                          >
                            <div
                              @click="changeTheme2()"
                              class="second-theme-item"
                            ></div>
                          </li>
                          <li
                            class="theme-item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="grey dark"
                          >
                            <div
                              @click="changeTheme3()"
                              class="third-theme-item"
                            ></div>
                          </li>
                          <li
                            class="theme-item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="brown orange"
                          >
                            <div
                              @click="changeTheme4()"
                              class="fourth-theme-item"
                            ></div>
                          </li>
                          <li
                            class="theme-item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="grey dark"
                          >
                            <div
                              @click="changeTheme5()"
                              class="fifth-theme-item"
                            ></div>
                          </li>
                        </ul>
                        <br />
                        <br />
                      </div>
                      <div class="sideMenu">
                        <p style="font-weight: 100;" class="text-left">
                          Side menu:
                        </p>
                        <label class="switch">
                          <input
                            @click="toggleSideBar()"
                            class="checkbox-sidebar"
                            type="checkbox"
                            checked
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                      <!--<div class="mode">
                        <p style="font-weight: 100;" class="text-left">
                          Mode:(Light/Dark)
                        </p>
                        <label class="switch">
                          <input
                            @click="toggleMode()"
                            class="checkbox-mode"
                            type="checkbox"
                            checked
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>

                      <p style="font-weight: 100;" class="text-left">
                        Font Family:
                      </p>
                      <p class="text-center"></p>
                      <br />-->
                    </div>
                  </div>
                </li>
                <li class="inline mx-2">
                  <p
                    class="text-white inline dropdown-toggle"
                    style="cursor:pointer;"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Menu
                  </p>
                  <div
                    class="dropdown-menu shadow"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <br />
                    <ul id="Authenticated" class="list">
                      <!--<li class="dropdown-item text-dark">
                        <router-link class="" id="rl" to="/"
                          ><i class="fas mr-2 fa-home"></i> Home</router-link
                        >
                      </li>-->
                      <li class="dropdown-item text-dark">
                        <router-link class="" id="rl" to="/dashboard"
                          ><i class="fas mr-2 fa-columns"></i>
                          Dashboard</router-link
                        >
                      </li>
                      <li
                        @click="logOut"
                        style="cursor:pointer; color:red;"
                        class="dropdown-item"
                      >
                        <i class="fas mr-2 fa-sign-out-alt"></i> Log Out
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu-mobile-device">
      <div class="menu-list-moblie-devices">
        <ul v-if="!token" id="notAuthenticated" class="text-left">
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <router-link to="/login" tag="p" class="text-white"
              >Log in</router-link
            >
          </li>
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <router-link to="/register" tag="p" class="text-white"
              >Register</router-link
            >
          </li>
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <router-link to="/projects" tag="p" class="text-white"
              >Browse Projects</router-link
            >
          </li>
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <a
              href="https://github.com/mouadTaoussi/post-freelance-projects"
              class="text-white"
              target="_blank"
              >Source code</a
            >
          </li>
        </ul>
        <ul v-else class="text-left">
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <router-link class="text-white" tag="p" to="/dashboard">Dashboard</router-link>
          </li>
          <li
            @click="logOut" style="cursor:pointer;" class="text-white list-unstyled mb-4">Log Out
          </li>
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <router-link to="/projects" tag="p" class="text-white"
              >Browse Projects</router-link
            >
          </li>
          <li style="cursor: pointer;" class="text-white list-unstyled mb-4">
            <a
              href="https://github.com/mouadTaoussi/post-freelance-projects"
              class="text-white"
              target="_blank"
              >Source code</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerComponent",
  props: {
    isToggleSideBar: Boolean,
    isToggleMode: Boolean,
  },

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN
      // Holy guacamole! You should check in on some of those fields below.
      // This day is  icredibble day for programmer because of thier  256th day of each year!
      // if you are a programmer happy new year!
      ad: /*`鳄梨调味酱！您应该在下面的某些字段中签入。` ||*/ false,
    };
  },
  created() {
    // SET CHECKBOX TO RIGHT STATE
    window.setTimeout(() => {
      window.document.querySelector(
        ".checkbox-sidebar"
      ).checked = this.isToggleSideBar;
      window.document.querySelector(
        ".checkbox-mode"
      ).checked = this.isToggleMode;
    });

    // ANNOUNCEMENTS
    window.setInterval(() => {
      if (
        this.ad ===
        `因为每年的256天，这一天对于程序员来说都是回旋的一天！如果您是程序员新年快乐！`
      ) {
        // this.ad = " ";

        window.setTimeout(() => {
          this.ad = `鳄梨调味酱！您应该在下面的某些字段中签入。`;
        }, 100);
      } else if (this.ad === `鳄梨调味酱！您应该在下面的某些字段中签入。`) {
        // this.ad = " ";

        window.setTimeout(() => {
          this.ad = `因为每年的256天，这一天对于程序员来说都是回旋的一天！如果您是程序员新年快乐！`;
        }, 100);
      } else {
        // console.log('he')
      }
    }, 2000);
  },
  methods: {
    logOut: function() {
      // DELETE ACCESS TOKEN FROM LOCAL STORAGE
      window.localStorage.removeItem("access-token");

      // RELOAD TO UPDATE HEADER
      window.location.reload();

      // REDIRECT TO HOME
      this.$router.push("/");

      // window.location.reload();
    },
    // CHANGING THEME
    changeTheme1: () => {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "black"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#10ac84"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn

      // save changes on local storage
      window.localStorage.setItem(
        "theme",
        JSON.stringify({ theme: "default" })
      );
    },
    changeTheme2: () => {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#0c2461"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#f53b57"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn

      // save changes on local storage
      window.localStorage.setItem("theme", JSON.stringify({ theme: "pink" }));
    },
    changeTheme3: () => {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "black"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "red"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#e84118");

      // set a border on clicked btn

      // save changes on local storage
      window.localStorage.setItem("theme", JSON.stringify({ theme: "red" }));
    },
    changeTheme4: () => {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#c23616"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#e84118"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn

      // save changes on local storage
      window.localStorage.setItem("theme", JSON.stringify({ theme: "brown" }));
    },
    changeTheme5: () => {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#3c40c6"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#575fcf"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn

      // save changes on local storage
      window.localStorage.setItem("theme", JSON.stringify({ theme: "blue" }));
    },
    toggleSideBar() {
      const checkbox = window.document.querySelector(".checkbox-sidebar")
        .checked;

      this.$emit("toggleSideBar", checkbox);
    },
    showMenuForSmallerDevices() {
      const menuSection = window.document.querySelector(".menu-mobile-device");
      const menulist = window.document.querySelector(
        ".menu-list-moblie-devices"
      );

      // Check if the menu shown or not
      // there is good ways to do that!! but i don't know them honestly!!
      if (menuSection.style.height == "0px") {
        // Scale the height of it
        menuSection.style.height = "200px";
        menulist.style.display = "block";
      } else {
        // Hide it
        menuSection.style.height = "0px";
        menulist.style.display = "none";
      }
      // .menu-mobile-device {
      //   height: 0px;
      //   width: 100%;
      //   background: black;
      //   transition: all .2s ease-out;
      // }
    },
  },
};
</script>

<style lang="css" scoped>
#nav {
  padding: 40px;
  background-color: var(--bg-color-darker);
  color: white;
  height: 80px !important;
  /*border-bottom: 3px solid var(--main-btn-color);*/
}
.ad {
  /*height: 40px!important;*/
  background-color: var(--primary-color);
  color: white;
  margin: 0 !important;
  height: 50.23px !important;
}

#nav a {
  font-weight: bold;
  color: white;
}
.menu-auth {
  top: -15px;
  position: relative;
}
.list {
  list-style: none;
  padding: 0;
}
.list li {
  /*color: grey!important;*/
}
.list-not-auth {
  list-style: none;
  padding: 0;
  float: right;
  top: -15px;
  position: relative;
}
.list-not-auth li {
  display: inline;
  /*color: var(--text-color);*/
  /*display: inline;*/
}
.dropdown-itm {
  color: rgba(0, 0, 0, 0.89) !important;
}
.btn-red {
  background-color: var(--danger);
}
.search-input {
  width: 200px;
}
#rl {
  color: rgba(0, 0, 0, 0.89) !important;
}
.brand {
  position: relative;
  top: -12px;
  width: 200px;
  margin-right: 0;
}
#brand {
  width: 200px;
  margin-right: 0;
}
.inline {
  display: inline;
}
.m-1 {
  margin: 2px !important;
}
.settingsIcon:hover {
  -ms-transform: rotate(10deg); /* IE 9 */
  transform: rotate(10deg);
}
.primary {
  background-color: white;
}
.red {
  background-color: var(--dan-ger);
}
.theme-item {
  display: inline !important;
  padding: 3px;
  float: left;
}
.first-theme-item,
.second-theme-item,
.third-theme-item,
.fourth-theme-item,
.fifth-theme-item {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid transparent;
}
.first-theme-item {
  background-color: #10ac84;
}
.second-theme-item {
  background-color: #f53b57;
}
.third-theme-item {
  background-color: red;
}
.fourth-theme-item {
  background-color: #c23616;
}
.fifth-theme-item {
  background-color: #575fcf;
}
/******************From: https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_switch********************/

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 17px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(21px);
  -ms-transform: translateX(21px);
  transform: translateX(21px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.primary-text {
  color: var(--primary-color);
}
.success {
  background-color: var(--succ-ess);
}
.menu-mobile-device {
  height: 0px;
  width: 100%;
  background: var(--bg-color-darker);
  transition: all 0.2s ease-out;
}
.menu-list-moblie-devices {
  display: none;
  transition: all 1s ease-out !important;
}
.menu-icon {
  font-size: 20px;
  display: none;
  margin-top: -38px;
  width: 40px !important;
  float: right;
}
.settingsIcon-sm-device {
  display: none;
}
/**************************************/
@media only screen and (max-width: 600px) {
  .ad,
  .source-code,
  .header-menus {
    /*font-size: 13px!important;*/
    display: none !important;
  }
  .menu-icon,
  .settingsIcon-sm-device {
    display: block;
  }
  #nav {
    padding: 25px;
    height: 60px !important;
  }
  .list {
    margin: 0 auto !important;
    font-size: 15px !important;
  }
  .menu-auth,
  .list-not-auth {
    float: left !important;
    /*display: none;*/
  }
  .logo {
    font-size: 15px !important;
  }
}
</style>
